import { OrderOverviewEffect } from './order-overview.effect';

export const effects: any[] = [
  OrderOverviewEffect,
];
